import { NgClass, NgIf, TitleCasePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { JoyrideModule } from 'ngx-joyride';
import { NgbDatepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { Angulartics2OnModule } from 'angulartics2';

import { WhatsappToggleModule } from '@tablesready/frontend-whatsapp-toggle';
import { WaitlistAddEditPartyComponent } from './waitlist-add-edit-party.component';
import {
  CommonRadioGroupModule,
  FormValidationModule,
  PipesModule,
  TimepickerModule,
  UtilsModule,
} from '@tablesready/common-ui';
import { PartyCustomFieldsModule } from '@tablesready/frontend-party-custom-fields';
import { IonicModule } from '@ionic/angular';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendModalModule } from '@tablesready/frontend-modal';

@NgModule({
  declarations: [WaitlistAddEditPartyComponent],
  exports: [WaitlistAddEditPartyComponent],
  imports: [
    FrontendIconsModule,
    FormValidationModule,
    FormsModule,
    UtilsModule,
    NgClass,
    JoyrideModule,
    WhatsappToggleModule,
    CommonRadioGroupModule,
    NgbDatepickerModule,
    TimepickerModule,
    NgSelectModule,
    Angulartics2OnModule,
    NgIf,
    TitleCasePipe,
    NgbTooltipModule,
    PipesModule,
    PartyCustomFieldsModule,
    IonicModule,
    FrontendDropdownModule,
    FrontendModalModule,
  ],
})
export class WaitlistAddEditPartyModule {}
